var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddCircleOutline20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14a1 1 0 01-1-1v-2H7a1 1 0 010-2h2V7a1 1 0 012 0v2h2a1 1 0 010 2h-2v2a1 1 0 01-1 1z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm2 0a6 6 0 1112 0 6 6 0 01-12 0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDE0QzkuNDQ3NzUgMTQgOSAxMy41NTIyIDkgMTNMOSAxMUw3IDExQzYuNDQ3NzUgMTEgNiAxMC41NTIyIDYgMTBDNiA5LjQ0Nzc1IDYuNDQ3NzUgOSA3IDlMOSA5TDkgN0M5IDYuNDQ3NzUgOS40NDc3NSA2IDEwIDZDMTAuNTUyMiA2IDExIDYuNDQ3NzUgMTEgN0wxMSA5TDEzIDlDMTMuNTUyMiA5IDE0IDkuNDQ3NzUgMTQgMTBDMTQgMTAuNTUyMiAxMy41NTIyIDExIDEzIDExTDExIDExTDExIDEzQzExIDEzLjU1MjIgMTAuNTUyMiAxNCAxMCAxNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIgMTBDMiA1LjU4MTcyIDUuNTgxNzIgMiAxMCAyQzE0LjQxODMgMiAxOCA1LjU4MTcyIDE4IDEwQzE4IDE0LjQxODMgMTQuNDE4MyAxOCAxMCAxOEM1LjU4MTcyIDE4IDIgMTQuNDE4MyAyIDEwWk00IDEwQzQgNi42ODYyOSA2LjY4NjI5IDQgMTAgNEMxMy4zMTM3IDQgMTYgNi42ODYyOSAxNiAxMEMxNiAxMy4zMTM3IDEzLjMxMzcgMTYgMTAgMTZDNi42ODYyOSAxNiA0IDEzLjMxMzcgNCAxMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgAddCircleOutline20 as ReactComponent };